'use strict';

var _tippy = require('tippy.js');

// import 'tippy.js/dist/tippy.css';
// import 'tippy.js/themes/light.css';

/*-------------------------
Tooltips
-------------------------*/

document.addEventListener('DOMContentLoaded', function (event) {
  // Beige
  (0, _tippy.delegate)('body', {
    duration: 500,
    target: '.tippy--beige',
    interactive: true,
    allowHTML: true,
    theme: 'beige',
    maxWidth: 260,
    trigger: 'mouseenter click'
    // Debugging Purposes
    /* hideOnClick: false,
    trigger: 'click', */
  });

  // Blue
  (0, _tippy.delegate)('body', {
    duration: 500,
    target: '.tippy--blue',
    interactive: true,
    allowHTML: true,
    theme: 'blue',
    maxWidth: 260,
    trigger: 'mouseenter click'
    // Debugging Purposes
    /* hideOnClick: false,
    trigger: 'click', */
  });
});